import React from 'react';
import { inject, observer } from 'mobx-react';
import LazyLoad from 'react-lazy-load';
import { Link } from 'react-router';
import { toJS } from 'mobx';
import commonAppImg from '../../style/img/commonApp.png';
import util from '../../util';
const { isWeaver } = util;
const isweaver = isWeaver();
const store = ['modeListStore', 'listStore', 'homeStore']
@inject(...store)
@observer
class App extends React.Component {
  static defaultProps = {
    prefixCls: 'app',
  }
  view = (e) => {
    const { modeListStore: { getAppDetail }, data, homeStore: { view } } = this.props;
    getAppDetail({ id: data.sw_id }).then((res) => {
      view(res.app);
      // window.open('http://203.110.166.60:8088/login/login4wf.jsp?userid=1&gopage=' +
      // `/cloudstore/system/index.jsp#/${res.app.s_number}/set`);
    });
    e.stopPropagation && e.stopPropagation();
    e.preventDefault && e.preventDefault();
    e.nativeEvent && e.nativeEvent.preventDefault();
  } 
  collect = (e) => {
    e.stopPropagation && e.stopPropagation();
    e.preventDefault && e.preventDefault();
    e.nativeEvent && e.nativeEvent.preventDefault();
    if (!isweaver) return;
    const { listStore: { params: { searchValue } }, modeListStore: { getCollectList, getModeList, setMobxState, modeType, callCollect }, data } = this.props;
    const isCollectPage = window.location.hash.indexOf('/collectList') >= 0;
    callCollect({ collect: data.tms_iscoll === '1' ? '0' : '1', s_ids: data.sw_id }).then(data => {
      setMobxState({ current: 1 });
      const param = { searchValue, current: 1, module: modeType };
      isCollectPage ? getCollectList(param) : getModeList(param);
    });
  }
  apply = (e, id) => {
    e.stopPropagation && e.stopPropagation();
    e.preventDefault && e.preventDefault();
    e.nativeEvent && e.nativeEvent.preventDefault();
    if (!isweaver) return;
    const { apply } = this.props;
    typeof apply === 'function' && apply(id);
  }
  linkDetail = () => {
    const { data, modeListStore: { routing } } = this.props;
    routing.push(`/app/appDetail/${data.sw_id}`);
  }
  render() {
    const server = window.server;
    const { data, prefixCls, homeStore: { type } } = this.props;
    const needView = toJS(type).id !== 'nStandard';
    return (
      <Link to={`app/appDetail/${data.sw_id}`}>
        <div className={`${prefixCls}`} onClick={this.linkDetail}>
          <div className={`${prefixCls}-img`}>
            <LazyLoad height='100%'>
              <img onError={(e) => { e.target.onerror = null; e.target.src = commonAppImg; }} src={`${data.s_pictureNati ? server + data.s_pictureNati : commonAppImg}`} alt='' />
            </LazyLoad>
          </div>
          <div className={`${prefixCls}-content`}>
            <div className={`${prefixCls}-content-name ${prefixCls}-text-elli`} title={data.s_name}>{data.s_name}</div>
            <div className={`${prefixCls}-content-btns`}>
              {
                needView && (<span className={`${prefixCls}-content-btns-single`} onClick={this.view}>预览</span>)
              }
              <span className={`${prefixCls}-content-btns-single ${!isweaver && 'cs-btn-disabled'}`} onClick={(e) => this.apply(e, data.sw_id)}>申请</span>
              <span className={`${prefixCls}-content-btns-single ${!isweaver && 'cs-btn-disabled'}`} onClick={this.collect}>{data.tms_iscoll === '1' ? '收藏' : '取消收藏'}</span>
            </div>
          </div>
        </div>
      </Link>
    )
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/mode/Apps.js